/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFileMusic = createReactComponent("file-music", "IconFileMusic", [
  ["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }],
  [
    "path",
    {
      d: "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M11 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", key: "svg-2" }],
  ["path", { d: "M12 16l0 -5l2 1", key: "svg-3" }]
]);

export { IconFileMusic as default };
//# sourceMappingURL=IconFileMusic.js.map
